import validate from "/home/circleci/project/node_modules/.pnpm/nuxt@3.12.3_@types+node@26.6.4_db0@0.3.4_eslint@10.5.0_jiti@1.21.7__ioredis@5.11.1_magi_8d21000ce59138e80d0aa0f7c5d6b696/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/circleci/project/node_modules/.pnpm/nuxt@3.12.3_@types+node@26.6.4_db0@0.3.4_eslint@10.5.0_jiti@1.21.7__ioredis@5.11.1_magi_8d21000ce59138e80d0aa0f7c5d6b696/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}